var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationCommentbubblesBlue = function SvgSimpleIllustrationCommentbubblesBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__commentbubbles_blue_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 68 68"
    }
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__commentbubbles_blue_svg__st2{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 37.082s-5.432-7.6-3.379-12.306c2.048-4.71 4.946-12.07 18.824-12.19 13.877-.12 18.223 12.791 17.501 17.136s-6.758 11.585-13.637 12.671-10.138-.12-10.138-.12-6.638 3.74-13.396 1.688c0 0 3.499-4.346 4.225-6.879z",
    style: {
      fill: "#4ed7de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.21 24.411s1.932 9.777-5.067 14.242c-6.033 3.62-9.171 4.706-17.257 4.105 0 0 .726 4.946 6.277 8.205s12.671 3.985 15.93 2.533c0 0 9.172 3.139 13.517 1.567 0 0-4.225-5.552-4.105-7.239 0 0 4.826-4.586 3.62-10.863-1.207-6.277-7.724-12.19-12.911-12.551h-.004z",
    style: {
      fill: "#99f6ff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.682 36.829c-.457 3.551-4.277 7.223-4.277 7.223s9.584 1.022 13.942-1.607M22.37 42.441c1.96 6.662 9.139 11.601 17.693 11.601 1.732 0 3.407-.201 4.995-.581M54.723 47.845c2.241-2.537 3.564-5.672 3.564-9.071 0-6.851-5.387-12.647-12.803-14.579M54.723 47.845C55.18 51.396 59 55.068 59 55.068s-9.584 1.022-13.942-1.607",
    className: "simple-illustration__commentbubbles_blue_svg__st2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.682 36.829c-2.241-2.537-3.564-5.672-3.564-9.071 0-8.43 8.157-15.264 18.223-15.264 10.065 0 18.223 6.834 18.223 15.268 0 8.434-8.157 15.268-18.223 15.268-1.732 0-3.407-.2-4.995-.581",
    className: "simple-illustration__commentbubbles_blue_svg__st2"
  })));
};
export default SvgSimpleIllustrationCommentbubblesBlue;